class AutoSubmitForm {
    constructor(form) {
        this.form = form;
        this.triggers = this.form.querySelectorAll('.js-auto-submit-trigger');

        this.triggers.forEach((trigger) => {
            trigger.addEventListener('change', this.handleTriggerAction.bind(this));
        });
    }

    handleTriggerAction() {
        this.form.submit();
        this.form.scrollIntoView();
    }
}

const autoSubmitForm = {
    init() {
        document.querySelectorAll('.js-auto-submit-form')
            .forEach((element) => {
                // eslint-disable-next-line no-new
                new AutoSubmitForm(element);
            });
    },
};

export default autoSubmitForm;
